// import axios from 'axios';
// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import { useAuthHeaders } from '../../../components/Token';
// import { API_BASE_URL } from '../../../utils';
// import { Container, Row, Col, Card, Table, Spinner } from 'react-bootstrap';

// export default function RequestedpageView() {
//     const { id } = useParams();
//     const headers = useAuthHeaders();
//     const [data, setData] = useState(null);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const response = await axios.get(`${API_BASE_URL}/vendor/${id}`, { headers });
//                 setData(response.data.vendor);
//             } catch (error) {
//                 console.error("Error fetching vendor data", error);
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchData();
//     }, [id]);

//     if (loading) {
//         return (
//             <Container className="text-center mt-5">
//                 <Spinner animation="border" />
//             </Container>
//         );
//     }

//     if (!data) {
//         return <Container className="text-center mt-5">No data available</Container>;
//     }

//     return (
//         <Container className="mt-4">
//             <Card>
//                 <Card.Header><h4>Vendor Details</h4></Card.Header>
//                 <Card.Body>
//                     <Table bordered hover>
//                         <tbody>
//                             <tr><td><b>Company Name</b></td><td>{data.companyName}</td></tr>
//                             <tr><td><b>Brand</b></td><td>{data.brand}</td></tr>
//                             <tr><td><b>Job Title</b></td><td>{data.jobTitle}</td></tr>
//                             <tr><td><b>Contact Name</b></td><td>{data.firstName} {data.lastName}</td></tr>
//                             <tr><td><b>Email</b></td><td>{data.email}</td></tr>
//                             <tr><td><b>Phone Number</b></td><td>{data.phoneNumber}</td></tr>
//                             <tr><td><b>Country</b></td><td>{data.country}</td></tr>
//                             <tr><td><b>Business Process Software</b></td><td>{data.businessProcessSoftware}</td></tr>
//                             <tr><td><b>Main Product</b></td><td>{data.mainProductDescription}</td></tr>
//                             <tr><td><b>Manufacturing Country</b></td><td>{data.manufacturingCountry}</td></tr>
//                             <tr><td><b>Turnover</b></td><td>{data.turnover}</td></tr>
//                             <tr><td><b>Approval Status</b></td><td>{data.approvelStatus}</td></tr>
//                             <tr><td><b>Year of Establishment</b></td><td>{data.yearOfEstablishment}</td></tr>
//                             <tr><td><b>Company Size</b></td><td>{data.companySize}</td></tr>
//                             <tr><td><b>GSTIN</b></td><td>{data.GSTIN}</td></tr>
//                             <tr><td><b>PAN</b></td><td>{data.PAN}</td></tr>
//                             <tr><td><b>CIN</b></td><td>{data.CIN}</td></tr>
//                             <tr><td><b>Registered Address</b></td><td>{data.registeredAddress}</td></tr>
//                             <tr><td><b>Shipping Address 1</b></td><td>{data.shippingAddress1}</td></tr>
//                             <tr><td><b>Shipping Address 2</b></td><td>{data.shippingAddress2}</td></tr>
//                             <tr><td><b>Minimum Order Quantity</b></td><td>{data.minOrderQuantity}</td></tr>
//                             <tr><td><b>Number of Products</b></td><td>{data.numberOfProducts}</td></tr>
//                             <tr><td><b>Pricing Management</b></td><td>{data.pricingManagement}</td></tr>
//                             <tr><td><b>Product Labels with Barcode</b></td><td>{data.productLabelsWithBarcode ? 'Yes' : 'No'}</td></tr>
//                             <tr><td><b>Supplier Portal Experience</b></td><td>{data.supplierPortalExperience ? 'Yes' : 'No'}</td></tr>
//                             <tr><td><b>Average Lead Time</b></td><td>{data.avgLeadTime}</td></tr>
//                             <tr><td><b>Bank Details</b></td><td>Account Number: {data.bankDetails.accountNumber}, Bank: {data.bankDetails.bankName}, Branch: {data.bankDetails.branch}, IFSC: {data.bankDetails.IFSC}</td></tr>
//                         </tbody>
//                     </Table>
//                 </Card.Body>
//             </Card>
//         </Container>
//     );
// }
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import {
  Container,
  Spinner,
  Table,
  Card,
  Button,
  Modal,
} from "react-bootstrap";
import { API_BASE_URL } from "../../../utils";
import { useAuthHeaders } from "../../../components/Token";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import RedesignedPermissionsForm from "../PermissionVendors";

export default function RequestedpageView() {
  const { id } = useParams();
  const headers = useAuthHeaders();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/vendor/${id}`, {
          headers,
        });
        setData(response.data.vendor);
      } catch (error) {
        console.error("Error fetching vendor data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const openPreview = (url) => {
    setPreviewUrl(url);
    setShowModal(true);
  };

  const renderDocumentActions = (url) => {
    if (!url) return <span className="text-muted">No file uploaded</span>;

    return (
      <>
        <Button
          size="sm"
          variant="info"
          onClick={() => openPreview(url)}
          className="me-2"
        >
          View
        </Button>
        <a href={url} download target="_blank" rel="noreferrer">
          <Button size="sm" variant="secondary">
            Download
          </Button>
        </a>
      </>
    );
  };

  const renderPopupViewer = () => (
    <Modal size="lg" show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Document Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {previewUrl && previewUrl.toLowerCase().endsWith(".pdf") ? (
          <div style={{ height: "500px" }}>
            <Worker
              workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}
            >
              <Viewer
                fileUrl={previewUrl}
                plugins={[defaultLayoutPluginInstance]}
              />
            </Worker>
          </div>
        ) : (
          <img
            src={previewUrl}
            alt="Document Preview"
            style={{ maxWidth: "100%" }}
          />
        )}
      </Modal.Body>
    </Modal>
  );

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
      </Container>
    );
  }

  if (!data) {
    return (
      <Container className="text-center mt-5">No data available</Container>
    );
  }

  return (
    <Container className="mt-4">
      <Card>
        <Card.Header>
          <h4>Vendor Details</h4>
        </Card.Header>
        <Card.Body>
          <Table bordered hover>
            <tbody>
              <tr>
                <td>
                  <b>Company Name</b>
                </td>
                <td>{data.companyName}</td>
              </tr>
              <tr>
                <td>
                  <b>Brand</b>
                </td>
                <td>{data.brand}</td>
              </tr>
              <tr>
                <td>
                  <b>Job Title</b>
                </td>
                <td>{data.jobTitle}</td>
              </tr>
              <tr>
                <td>
                  <b>Contact Name</b>
                </td>
                <td>
                  {data.firstName} {data.lastName}
                </td>
              </tr>
              <tr>
                <td>
                  <b>Email</b>
                </td>
                <td>{data.email}</td>
              </tr>
              <tr>
                <td>
                  <b>Phone Number</b>
                </td>
                <td>{data.phoneNumber}</td>
              </tr>
              <tr>
                <td>
                  <b>Country</b>
                </td>
                <td>{data.country}</td>
              </tr>
              <tr>
                <td>
                  <b>Manufacturing Country</b>
                </td>
                <td>{data.manufacturingCountry}</td>
              </tr>
              <tr>
                <td>
                  <b>Year of Establishment</b>
                </td>
                <td>{data.yearOfEstablishment}</td>
              </tr>
              <tr>
                <td>
                  <b>Company Size</b>
                </td>
                <td>{data.companySize}</td>
              </tr>
              <tr>
                <td>
                  <b>Turnover</b>
                </td>
                <td>{data.turnover}</td>
              </tr>
              <tr>
                <td>
                  <b>Main Product</b>
                </td>
                <td>{data.mainProductDescription}</td>
              </tr>
              <tr>
                <td>
                  <b>Business Software</b>
                </td>
                <td>{data.businessProcessSoftware}</td>
              </tr>
              <tr>
                <td>
                  <b>GSTIN</b>
                </td>
                <td>{data.GSTIN}</td>
              </tr>
              <tr>
                <td>
                  <b>GST Document</b>
                </td>
                <td>{renderDocumentActions(data.gstDocument)}</td>
              </tr>
              <tr>
                <td>
                  <b>PAN</b>
                </td>
                <td>{data.PAN}</td>
              </tr>
              <tr>
                <td>
                  <b>PAN Document</b>
                </td>
                <td>{renderDocumentActions(data.panDocument)}</td>
              </tr>
              <tr>
                <td>
                  <b>CIN</b>
                </td>
                <td>{data.CIN}</td>
              </tr>
              <tr>
                <td>
                  <b>CIN Document</b>
                </td>
                <td>{renderDocumentActions(data.cinDocument)}</td>
              </tr>
              <tr>
                <td>
                  <b>Bank Details</b>
                </td>
                <td>
                  A/C No: {data.bankDetails?.accountNumber},<br />
                  Bank: {data.bankDetails?.bankName}, Branch:{" "}
                  {data.bankDetails?.branch}, IFSC: {data.bankDetails?.IFSC}
                  <br />
                  {renderDocumentActions(data.bankDetails?.bankDocument)}
                </td>
              </tr>
              <tr>
                <td>
                  <b>Registered Address</b>
                </td>
                <td>{data.registeredAddress}</td>
              </tr>
              <tr>
                <td>
                  <b>Shipping Address 1</b>
                </td>
                <td>{data.shippingAddress1}</td>
              </tr>
              <tr>
                <td>
                  <b>Shipping Address 2</b>
                </td>
                <td>{data.shippingAddress2}</td>
              </tr>
              <tr>
                <td>
                  <b>Minimum Order Quantity</b>
                </td>
                <td>{data.minOrderQuantity}</td>
              </tr>
              <tr>
                <td>
                  <b>Number of Products</b>
                </td>
                <td>{data.numberOfProducts}</td>
              </tr>
              <tr>
                <td>
                  <b>Pricing Management</b>
                </td>
                <td>{data.pricingManagement}</td>
              </tr>
              <tr>
                <td>
                  <b>Product Labels with Barcode</b>
                </td>
                <td>{data.productLabelsWithBarcode ? "Yes" : "No"}</td>
              </tr>
              <tr>
                <td>
                  <b>Supplier Portal Experience</b>
                </td>
                <td>{data.supplierPortalExperience ? "Yes" : "No"}</td>
              </tr>
              <tr>
                <td>
                  <b>Average Lead Time</b>
                </td>
                <td>{data.avgLeadTime}</td>
              </tr>
            </tbody>
          </Table>
        </Card.Body>
      </Card>
      {renderPopupViewer()}

      <RedesignedPermissionsForm data={data} />
    </Container>
  );
}
